import React from "react"
import BagItemDetails from "./BagItemDetails"
import { graphql, useStaticQuery } from "gatsby"
import { getIsFrance } from "../../services/locale"

const BagItem = ({ bagItem, gift , productGallery, totalQuantity}) => {
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      productContents: allContentfulProductContent {
        nodes {
          ...ProductCardContentFragment
        }
      }
      shopifyProducts: allShopifyProduct {
        nodes {
          createdAt
          handle
          metafields {
            key
            value
          }
          shopifyId
        }
      }
    }
  `)
  const { productContents, shopifyProducts } = data
  const product = bagItem

  let content = productContents.nodes.find(
    (content) => content.productHandle === product.handle
  )

  let shopifyProduct = shopifyProducts.nodes.find((shopifyProduct) => shopifyProduct.handle === product.handle)

  const isFrance = getIsFrance()

  const titleFr =
    shopifyProduct.metafields.length > 0 &&
    shopifyProduct.metafields.find((field) => field.key.trim() === "title_fr")
  const localisedTitle = !isFrance ? product.title : titleFr?.value || product.title

  if (content && content.urlKey) {
    product.handle = content.urlKey
    product.createdAt = shopifyProduct.createdAt
  }

  if (localisedTitle) {
    product.title = localisedTitle
  }

  const {
    handle,
    image,
    title,
    price,
    currencyCode,
    customAttributes,
    lineItemId,
    selectedOptions: options,
    quantity,
    discountAmount,
    createdAt
  } = product

  const lineItemIds = [lineItemId]
  const bagProps = {
    handle,
    image: image || productGallery,
    title,
    price: price.amount,
    currencyCode,
    customAttributes,
    lineItemIds,
    options,
    quantity,
    discountAmount,
    createdAt,
    allProducts: shopifyProducts.nodes,
  }

  return (
    <React.Fragment>
      <BagItemDetails {...bagProps} gift={gift} totalQuantity={totalQuantity} />
    </React.Fragment>
  )
}

export default BagItem
